namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerEditor()
    export class PsParaEditor extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PsParaRow> {

        constructor(hidden: JQuery, options: Serenity.LookupEditorOptions) {
            super(hidden, options);
        }

        protected getLookupKey() {
            return PsParaRow.lookupKey;
        }

        protected getItemText(item, lookup) {
            return super.getItemText(item, lookup) + ' [' + item.ShopName + ']';
        }
    }
}